import { useState } from 'react'
import renderCompImg from '../../../../../../source/Comp_Img'
import renderImage from '../../../../../../source/importImg'
// import circleImg1 from './whiteCircle.png'
// import circleImg2 from './redCircle.png'
// import pngImg1 from './rightImage.png'
// import pngImg2 from './leftImge.png'
// import whitetext from './whitetext.png'
// import blacktext from './blacktext.png'

function JoystickAutoMode({ swiped, setSwiped }) {
    return (
        <div
            style={{
                height: '60vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div
                onClick={() => setSwiped(!swiped)}
                style={{
                    width: '400px',
                    padding: '5px',
                    // border: '1px solid gray',
                    borderRadius: '140px',
                    boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
                    cursor: 'pointer',
                    userSelect: 'none',
                }}
            >
                {/* Inner container with background image */}
                <div
                    style={{
                        position: 'relative',
                        height: '195px',
                        borderRadius: '160px',
                        backgroundImage: `url(${swiped ? renderImage('leftZingImage') : renderImage('rightZingImage')})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        transition: 'background-image 0.5s ease',
                        overflow: 'hidden',
                    }}
                >
                    {/* Sliding circle */}
                    <div
                        style={{
                            position: 'absolute',
                            top: swiped ? '-9px' : '-9px',
                            left: swiped ? '182px' : '-10px',
                            width: swiped ? '230px' : '230px',
                            height: swiped ? '230px' : '230px',
                            borderRadius: '50%',
                            backgroundImage: `url(${swiped ? renderImage('redCircle') : renderImage('whiteCircle')})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            transition: 'all 0.5s ease',
                            // boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                        }}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: swiped ? '77px' : '80px',
                            left: swiped ? '248px' : '54px',
                            width: swiped ? '90px' : '90px',

                            transition: 'all 0.5s ease',
                        }}
                        src={
                            swiped
                                ? renderImage('hyperModeText')
                                : renderImage('normalModeText')
                        }
                        alt={swiped ? 'Hyper Mode' : 'Normal Mode'}
                    />
                </div>
            </div>
        </div>
    )
}

export default JoystickAutoMode
